/* IB2 — Cart drawer: AJAX add/change + Section Rendering refresh.
   Exposes window.IB2Cart { open, close, addFromForm, refresh }. */
(function () {
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var ADD_URL = ROOT + 'cart/add.js';
  var CHANGE_URL = ROOT + 'cart/change.js';
  var SECTION_URL = ROOT + '?sections=cart-drawer';

  function el(id) { return document.getElementById(id); }
  function drawer() { return el('CartDrawer'); }
  function overlay() { return el('CartOverlay'); }

  function open() {
    if (overlay()) overlay().classList.add('is-open');
    if (drawer()) drawer().classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function close() {
    if (overlay()) overlay().classList.remove('is-open');
    if (drawer()) drawer().classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function setLoading(on) {
    var d = drawer();
    if (d) d.classList.toggle('is-loading', !!on);
  }

  function updateHeaderCount(count) {
    var c = parseInt(count, 10) || 0;
    var bubble = document.querySelector('.cart-count');
    var cartIcon = document.querySelector('.header-icon--cart');
    if (c > 0) {
      if (!bubble && cartIcon) {
        bubble = document.createElement('span');
        bubble.className = 'cart-count';
        cartIcon.appendChild(bubble);
      }
      if (bubble) bubble.textContent = c;
    } else if (bubble) {
      bubble.remove();
    }
  }

  // Pull a freshly-rendered drawer from the Section Rendering API and swap it in.
  function refresh(shouldOpen) {
    setLoading(true);
    return fetch(SECTION_URL, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cart-drawer-root');
        var current = el('cart-drawer-root');
        if (fresh && current) {
          current.replaceWith(fresh);
          updateHeaderCount(fresh.getAttribute('data-item-count'));
          bind();
        }
        setLoading(false);
        if (shouldOpen) open();
      })
      .catch(function () { setLoading(false); });
  }

  function addFromForm(form) {
    if (!form) return;
    var data = new FormData(form);
    setLoading(true);
    open();
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: data
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          setLoading(false);
          var msg = (res.body && res.body.description) || 'Could not add to cart.';
          alert(msg);
          return;
        }
        return refresh(true);
      })
      .catch(function () { setLoading(false); });
  }

  // Add several items at once (e.g. the trio set). items = [{id, quantity}]
  function addItems(items) {
    if (!items || !items.length) return;
    setLoading(true);
    open();
    fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          setLoading(false);
          alert((res.body && res.body.description) || 'Could not add to cart.');
          return;
        }
        return refresh(true);
      })
      .catch(function () { setLoading(false); });
  }

  function changeLine(key, quantity) {
    setLoading(true);
    fetch(CHANGE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refresh(false); })
      .catch(function () { setLoading(false); });
  }

  // (Re)bind controls inside the drawer after each render.
  function bind() {
    document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.onclick = function (e) { e.preventDefault(); close(); };
    });
    document.querySelectorAll('.cart-line').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var qtyEl = line.querySelector('[data-qty]');
      var qty = parseInt(qtyEl && qtyEl.textContent, 10) || 1;
      var up = line.querySelector('[data-qty-up]');
      var down = line.querySelector('[data-qty-down]');
      var remove = line.querySelector('[data-line-remove]');
      if (up) up.onclick = function () { changeLine(key, qty + 1); };
      if (down) down.onclick = function () { changeLine(key, qty - 1); };
      if (remove) remove.onclick = function () { changeLine(key, 0); };
    });
  }

  function init() {
    bind();
    // Header cart icon → open drawer instead of navigating (keeps href fallback)
    var cartIcon = document.querySelector('.header-icon--cart');
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    }
    // Any [data-cart-open] trigger (e.g. mobile hamburger nav cart link)
    document.querySelectorAll('[data-cart-open]').forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        open();
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }

  window.IB2Cart = { open: open, close: close, addFromForm: addFromForm, addItems: addItems, refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
